import React from 'react';

export const OrganisationSettingsSection = ({ children }) => {
  return <section className="organisation-settings__section">{children}</section>;
};
